<section class="panel p-4">
  <h2 class="h5 mb-3">Cadastro do funcionario</h2>
  <form class="row g-3" (ngSubmit)="salvarFuncionario()">
    <div class="col-md-4">
      <label class="form-label">Filtrar por departamento</label>
      <app-seletor-multiplo-departamentos
        [departamentos]="departamentos"
        [idsSelecionados]="departamentoFiltro"
        (idsSelecionadosChange)="alterarDepartamentoFiltro($event)">
      </app-seletor-multiplo-departamentos>
    </div>

    <div class="col-md-8">
      <app-seletor-funcionario-existente
        [termo]="buscaFuncionario"
        [funcionarios]="funcionariosFiltrados"
        [rotuloItem]="rotuloFuncionario"
        [detalheItem]="detalheFuncionario"
        (termoChange)="alterarBusca($event)"
        (buscar)="abrirModalFuncionarios()"
        (selecionar)="selecionarFuncionario($event)">
      </app-seletor-funcionario-existente>
    </div>

    <app-painel-dados-funcionario
      class="row g-3"
      [funcionario]="funcionario"
      [empregadores]="empregadores"
      [departamentos]="departamentos"
      [jornadas]="jornadas"
      [empregadorSelecionado]="empregadorSelecionado"
      (funcionarioChange)="funcionarioChange.emit($event)"
      (empregadorSelecionadoChange)="empregadorSelecionadoChange.emit($event)"
      (alterarEmpregador)="alterarEmpregador.emit()"
      (digitouCpf)="digitouCpf.emit()">
    </app-painel-dados-funcionario>

    <div class="col-12">
      <app-painel-face-funcionario
        [funcionario]="funcionario"
        [statusFaceReferencia]="statusFaceReferencia"
        [cameraAtiva]="cameraAtiva"
        [cameraModo]="cameraModo"
        [rostoDetectado]="rostoDetectado"
        [provaVidaOk]="provaVidaOk"
        [capturando]="capturando"
        [mensagemCamera]="mensagemCamera"
        [caixaFace]="caixaFace"
        [limiteFacesReferencia]="limiteFacesReferencia"
        (validarFace)="abrirCameraValidacaoFuncionario()"
        (capturarFace)="abrirCameraCadastro()"
        (removerFace)="removerFaceFuncionario($event)"
        (confirmarFace)="capturarERegistrar()"
        (cancelarFace)="fecharCamera()">
      </app-painel-face-funcionario>
    </div>

    <div class="col-12">
      <app-rodape-crud
        [exibirExcluir]="true"
        [excluirDesabilitado]="!funcionario.id"
        (excluir)="excluirFuncionario()"
        (limpar)="limparFuncionario()"
        (salvar)="salvarFuncionario()">
      </app-rodape-crud>
    </div>

    <app-modal-pesquisa-funcionario
      [aberta]="modalFuncionariosAberta"
      [termo]="buscaFuncionarioModal"
      [funcionarios]="funcionariosModal"
      [rotuloItem]="rotuloFuncionario"
      [detalheItem]="detalheFuncionario"
      (termoChange)="buscaFuncionarioModal = $event"
      (selecionar)="selecionarFuncionario($event)"
      (limpar)="limparBuscaFuncionarioModal()"
      (fechar)="fecharModalFuncionarios()">
    </app-modal-pesquisa-funcionario>
  </form>
</section>
